// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    height?: number;
    width?: number;
}

const AirgappedTrialActivationConfirmSvg = ({height = 474, width = 578}: SvgProps) => (
    <svg
        width={width.toString()}
        height={height.toString()}
        viewBox='0 0 223 159'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g clipPath='url(#clip0_754_57919)'>
            <path
                d='M17.1671 115.779H174.208C175.364 115.763 176.466 115.281 177.273 114.439C178.081 113.597 178.528 112.464 178.516 111.287V4.46575C178.528 3.28926 178.081 2.15606 177.273 1.3142C176.466 0.47233 175.364 -0.00961028 174.208 -0.026123H17.1671C16.0121 -0.00797133 14.9109 0.474468 14.1039 1.31597C13.297 2.15748 12.8496 3.28974 12.8595 4.46575V111.294C12.8513 112.468 13.2993 113.599 14.1061 114.439C14.9129 115.279 16.0131 115.761 17.1671 115.779Z'
                fill='#3F4350'
            />
            <path
                d='M-0.15625 131.141C-0.15625 136.459 4.17094 141.776 9.41922 141.776H181.963C186.909 141.776 191.532 136.471 191.532 131.141H-0.15625Z'
                fill='#767D93'
            />
            <path
                d='M175.559 115.779H15.8173L-0.15625 131.141H191.532L175.559 115.779Z'
                fill='#D1D4DB'
            />
            <path
                d='M170.782 116.961H20.5884L15.2266 123.46H176.15L170.782 116.961Z'
                fill='#AFB3C0'
            />
            <path
                d='M112.155 125.823H79.2272L76.7559 129.369H114.62L112.155 125.823Z'
                fill='#24262E'
            />
            <g clipPath='url(#clip1_754_57919)'>
                <rect
                    width='146.725'
                    height='94.5349'
                    transform='translate(22.3262 10.0183)'
                    fill='white'
                />
                <rect
                    x='22.3262'
                    y='10.0183'
                    width='43.7808'
                    height='95.1258'
                    fill='#1E325C'
                />
                <ellipse
                    opacity='0.32'
                    cx='29.4256'
                    cy='17.6994'
                    rx='4.14142'
                    ry='4.1359'
                    fill='white'
                />
                <rect
                    opacity='0.32'
                    x='36.5254'
                    y='16.5176'
                    width='19.5238'
                    height='1.77253'
                    rx='0.886265'
                    fill='white'
                />
                <rect
                    opacity='0.32'
                    x='26.4678'
                    y='27.1528'
                    width='13.0159'
                    height='1.77253'
                    rx='0.886265'
                    fill='white'
                />
                <rect
                    opacity='0.32'
                    x='26.4678'
                    y='83.8738'
                    width='13.0159'
                    height='1.77253'
                    rx='0.886265'
                    fill='white'
                />
                <ellipse
                    opacity='0.32'
                    cx='28.5385'
                    cy='34.5382'
                    rx='2.07071'
                    ry='2.06795'
                    fill='white'
                />
                <rect
                    opacity='0.32'
                    x='32.9756'
                    y='33.6519'
                    width='24.5527'
                    height='1.69648'
                    rx='0.848242'
                    fill='white'
                />
                <ellipse
                    opacity='0.32'
                    cx='28.5385'
                    cy='55.8087'
                    rx='2.07071'
                    ry='2.06795'
                    fill='white'
                />
                <rect
                    opacity='0.32'
                    x='32.9756'
                    y='54.9224'
                    width='24.2569'
                    height='1.77253'
                    rx='0.886265'
                    fill='white'
                />
                <ellipse
                    opacity='0.32'
                    cx='28.5385'
                    cy='41.6285'
                    rx='2.07071'
                    ry='2.06795'
                    fill='white'
                />
                <rect
                    opacity='0.32'
                    x='32.9756'
                    y='40.7422'
                    width='21.2987'
                    height='1.77253'
                    rx='0.886264'
                    fill='white'
                />
                <ellipse
                    opacity='0.32'
                    cx='28.5385'
                    cy='62.8988'
                    rx='2.07071'
                    ry='2.06795'
                    fill='white'
                />
                <rect
                    opacity='0.32'
                    x='32.9756'
                    y='62.0125'
                    width='21.2987'
                    height='1.77253'
                    rx='0.886265'
                    fill='white'
                />
                <ellipse
                    opacity='0.32'
                    cx='28.5385'
                    cy='48.7186'
                    rx='2.07071'
                    ry='2.06795'
                    fill='white'
                />
                <rect
                    opacity='0.32'
                    x='32.9756'
                    y='47.8323'
                    width='27.8067'
                    height='1.77253'
                    rx='0.886265'
                    fill='white'
                />
                <ellipse
                    opacity='0.32'
                    cx='28.5385'
                    cy='69.9888'
                    rx='2.07071'
                    ry='2.06795'
                    fill='white'
                />
                <rect
                    opacity='0.32'
                    x='32.9756'
                    y='69.1025'
                    width='27.8067'
                    height='1.77253'
                    rx='0.886265'
                    fill='white'
                />
                <ellipse
                    opacity='0.32'
                    cx='28.5385'
                    cy='91.2594'
                    rx='2.07071'
                    ry='2.06795'
                    fill='white'
                />
                <rect
                    opacity='0.32'
                    x='32.9756'
                    y='90.373'
                    width='27.8067'
                    height='1.77253'
                    rx='0.886265'
                    fill='white'
                />
                <ellipse
                    opacity='0.32'
                    cx='28.5385'
                    cy='77.0789'
                    rx='2.07071'
                    ry='2.06795'
                    fill='white'
                />
                <rect
                    opacity='0.32'
                    x='32.9756'
                    y='76.1926'
                    width='18.3406'
                    height='1.77253'
                    rx='0.886265'
                    fill='white'
                />
                <ellipse
                    cx='74.3896'
                    cy='34.8336'
                    rx='3.54979'
                    ry='3.54506'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <rect
                    x='81.4893'
                    y='31.8794'
                    width='20.1155'
                    height='1.77253'
                    rx='0.886265'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <rect
                    x='81.4893'
                    y='37.197'
                    width='60.9381'
                    height='1.18169'
                    rx='0.590843'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <rect
                    x='81.4893'
                    y='41.9238'
                    width='68.6293'
                    height='1.18169'
                    rx='0.590843'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <ellipse
                    cx='74.3896'
                    cy='59.0582'
                    rx='3.54979'
                    ry='3.54506'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <rect
                    x='81.4893'
                    y='56.104'
                    width='20.1155'
                    height='1.77253'
                    rx='0.886265'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <rect
                    x='81.4893'
                    y='61.4216'
                    width='60.9381'
                    height='1.18169'
                    rx='0.590843'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <rect
                    x='81.4893'
                    y='66.1484'
                    width='68.6293'
                    height='1.18169'
                    rx='0.590843'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <ellipse
                    cx='74.3896'
                    cy='81.5104'
                    rx='3.54979'
                    ry='3.54506'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <rect
                    x='81.4893'
                    y='78.5562'
                    width='20.1155'
                    height='1.77253'
                    rx='0.886265'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <rect
                    x='81.4893'
                    y='83.8738'
                    width='60.9381'
                    height='1.18169'
                    rx='0.590843'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <rect
                    x='81.4893'
                    y='88.6006'
                    width='68.6293'
                    height='1.18169'
                    rx='0.590843'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <ellipse
                    cx='92.73'
                    cy='17.6993'
                    rx='1.77489'
                    ry='1.77253'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <ellipse
                    cx='124.086'
                    cy='17.6993'
                    rx='1.77489'
                    ry='1.77253'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <ellipse
                    cx='154.26'
                    cy='17.6993'
                    rx='1.77489'
                    ry='1.77253'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <ellipse
                    cx='159.584'
                    cy='17.6993'
                    rx='1.77489'
                    ry='1.77253'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <ellipse
                    cx='97.4634'
                    cy='17.6993'
                    rx='1.77489'
                    ry='1.77253'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <rect
                    x='70.8398'
                    y='17.1084'
                    width='18.3406'
                    height='1.18169'
                    rx='0.590843'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
                <rect
                    x='127.637'
                    y='16.5176'
                    width='23.0736'
                    height='2.36337'
                    rx='1.18169'
                    fill='#3F4350'
                    fillOpacity='0.24'
                />
            </g>
            <path
                d='M95.6878 2.92798C96.1559 2.92798 96.6134 3.06659 97.0026 3.32629C97.3918 3.58598 97.6951 3.95508 97.8742 4.38693C98.0533 4.81878 98.1002 5.29397 98.0089 5.75242C97.9175 6.21087 97.6922 6.63199 97.3612 6.96251C97.0303 7.29303 96.6086 7.51813 96.1495 7.60932C95.6905 7.70051 95.2146 7.65369 94.7822 7.47481C94.3497 7.29593 93.9801 6.99303 93.7201 6.60438C93.4601 6.21572 93.3213 5.75878 93.3213 5.29135C93.3213 4.66455 93.5707 4.06341 94.0145 3.62019C94.4583 3.17697 95.0602 2.92798 95.6878 2.92798Z'
                fill='#989DAE'
            />
            <path
                d='M109.322 138.231H81.4444C80.4823 138.231 77.9395 138.231 77.9395 134.686H112.846C112.846 138.231 110.228 138.231 109.322 138.231Z'
                fill='#3F4350'
            />
        </g>
        <g clipPath='url(#clip2_754_57919)'>
            <rect
                x='184.015'
                y='147.833'
                width='14.3123'
                height='2.45026'
                rx='1.22513'
                fill='#8D93A5'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M219.65 155.56C218.049 157.196 215.767 158.45 213.264 158.45H169.486C166.983 158.45 164.701 157.196 163.1 155.56C161.496 153.92 160.297 151.613 160.297 149.117V47.721C160.297 45.2239 161.494 42.9173 163.098 41.2769C164.698 39.6401 166.979 38.3875 169.482 38.3875H213.264C215.766 38.3875 218.048 39.6398 219.65 41.2762C221.254 42.9162 222.453 45.223 222.453 47.721V149.117C222.453 151.613 221.254 153.92 219.65 155.56ZM213.264 156C216.632 156 219.999 152.554 219.999 149.117V47.721C219.999 44.2793 216.632 40.8377 213.264 40.8377H169.482C166.114 40.8377 162.75 44.2793 162.75 47.721V149.117C162.75 152.554 166.118 156 169.486 156H213.264Z'
                fill='#363A45'
            />
            <path
                d='M220 149.117C220 152.554 216.632 156 213.265 156H169.486C166.119 156 162.751 152.554 162.751 149.117V47.7209C162.751 44.2793 166.115 40.8376 169.482 40.8376H213.265C216.632 40.8376 220 44.2793 220 47.7209V149.117Z'
                fill='#3F4350'
            />
            <path
                d='M196.283 46.7579C196.283 47.0974 196.068 47.3719 195.796 47.3719H186.959C186.691 47.3719 186.469 47.0889 186.469 46.7579C186.469 46.4268 186.691 46.1467 186.959 46.1467H195.781C196.053 46.1467 196.283 46.4212 196.283 46.7579Z'
                fill='#8D93A5'
            />
            <path
                d='M217.546 53.4976H165.204V143.749H217.546V53.4976Z'
                fill='white'
            />
            <ellipse
                cx='171.516'
                cy='71.2071'
                rx='3.53454'
                ry='3.52983'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <ellipse
                cx='171.516'
                cy='92.386'
                rx='3.53454'
                ry='3.52983'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <ellipse
                cx='171.516'
                cy='113.565'
                rx='3.53454'
                ry='3.52983'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <rect
                x='176.465'
                y='69.0891'
                width='24.0349'
                height='1.41193'
                rx='0.705966'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <rect
                x='176.465'
                y='90.2681'
                width='24.0349'
                height='1.41193'
                rx='0.705967'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <rect
                x='176.465'
                y='111.447'
                width='24.0349'
                height='1.41193'
                rx='0.705967'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <rect
                x='176.465'
                y='77.5608'
                width='33.9316'
                height='1.41193'
                rx='0.705966'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <rect
                x='176.465'
                y='98.7397'
                width='33.9316'
                height='1.41193'
                rx='0.705965'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <rect
                x='176.465'
                y='119.919'
                width='33.9316'
                height='1.41193'
                rx='0.705963'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <rect
                x='176.465'
                y='81.7966'
                width='16.9658'
                height='1.41193'
                rx='0.705966'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <rect
                x='176.465'
                y='102.976'
                width='16.9658'
                height='1.41193'
                rx='0.705965'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <rect
                x='176.465'
                y='124.155'
                width='16.9658'
                height='1.41193'
                rx='0.705967'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <rect
                x='176.465'
                y='73.325'
                width='36.7592'
                height='1.41193'
                rx='0.705966'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <rect
                x='176.465'
                y='94.5039'
                width='36.7592'
                height='1.41193'
                rx='0.705965'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <rect
                x='176.465'
                y='115.683'
                width='36.7592'
                height='1.41193'
                rx='0.705967'
                fill='#3F4350'
                fillOpacity='0.24'
            />
            <rect
                x='165.204'
                y='53.4976'
                width='52.342'
                height='9.80105'
                fill='#1E325C'
            />
            <rect
                opacity='0.4'
                x='173.791'
                y='57.9897'
                width='17.1747'
                height='1.22513'
                rx='0.612565'
                fill='white'
            />
            <rect
                opacity='0.4'
                x='210.595'
                y='56.3562'
                width='4.08922'
                height='4.08377'
                rx='2'
                fill='white'
            />
            <rect
                opacity='0.4'
                x='168.066'
                y='56.3562'
                width='4.08922'
                height='4.08377'
                rx='2'
                fill='white'
            />
        </g>
        <defs>
            <clipPath id='clip0_754_57919'>
                <rect
                    width='179'
                    height='142'
                    fill='white'
                />
            </clipPath>
            <clipPath id='clip1_754_57919'>
                <rect
                    width='146.725'
                    height='94.5349'
                    fill='white'
                    transform='translate(22.3262 10.0183)'
                />
            </clipPath>
            <clipPath id='clip2_754_57919'>
                <rect
                    width='63'
                    height='121'
                    fill='white'
                    transform='translate(160 38)'
                />
            </clipPath>
        </defs>
    </svg>

);

export default AirgappedTrialActivationConfirmSvg;
